import { Banner } from "@design";
import { FlaskConical } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BannerAction } from "@/components/BannerAction";
import { useAuth } from "../AuthContext";
import { useDevAuth } from "./DevAuthProvider";

/** App banner while signed in as a dev persona, with a one-click way to switch. */
export function DevPersonaBanner() {
  const dev = useDevAuth();
  const { logout } = useAuth();
  const { t } = useTranslation("devAuth");
  if (!dev?.persona) return null;
  const { name, role, devTeamRole } = dev.persona;
  return (
    <Banner
      variant="warning"
      icon={<FlaskConical size={14} />}
      message={
        devTeamRole
          ? t("banner.messageWithTeam", { name, role, teamRole: devTeamRole })
          : t("banner.message", { name, role })
      }
      action={<BannerAction onClick={() => logout()}>{t("banner.switch")}</BannerAction>}
    />
  );
}
